import { ProjectBlockProps } from './ProjectInterface';

export const projectContents: ProjectBlockProps[] = [
  {
    id: 'yetsul',
    name: '옛술의 전당',
    thumbnail: '/image/project/background/yetsul.png',
    logo: '/image/project/Logo/yetsulL.png',
    detailImg: null,
    cohort: '1기',
    projectType: 'MVP',
    platform: 'WEB',
    slogan: '청춘을 위한 한 잔, 옛술의 전당에서 건배!',
    description:
      '옛술의 전당은 ‘우리의 자랑스러운 전통주를 알리기 위해’ 시작되었습니다. 자신에게 어울리는 전통주를 찾고 전통주의 매력을 한층 더 느끼며, 전통주를 즐길 수 있게 하는 것을 목표로 제작하였고, 우리의 옛술이 더 이상 ‘전통주’ 자체가 아닌 모두가 함께 즐길 수 있는 술로 거듭나도록 다양한 서비스를 제공하고 있습니다.',
    serviceLink: 'https://www.yetsul.com/',
    githubLink: [
      'https://github.com/DEPthes/1st-Yetsul-Web',
      'https://github.com/DEPthes/1st-Yetsul-Server',
    ],
    member: {
      'TEAM LEADER': '이보현',
      'PM LEADER': '이여원',
      'WEB LEADER': '강상원',
      'SERVER LEADER': '김해찬',
      PM: ['문규원', '박상민', '김보은'],
      WEB: ['김희윤', '이보현', '이가은'],
      SERVER: '김현빈',
      DESIGN: '최성경',
    },
  },
  //2기 시작
  {
    id: 'ieum',
    name: '이:음',
    thumbnail: '/image/project/background/ieum.png',
    logo: '/image/project/logo/ieumL.png',
    detailImg: null,
    cohort: '2기',
    projectType: 'MVP',
    platform: 'WEB',
    slogan: '편지의 따뜻한 위로를 전하는 랜덤 익명 편지 서비스',
    description:
      '자신의 감정을 글로 적는 과정에서 해소가 이루어지기도 하고, 익명의 누군가와 편지를 주고 받으며 예상치 못한 사람에게 예상치 못한 답변을 받기도 하죠. 이:음에서 정성이 담긴 편지의 온기를 다시 느껴보세요.',
    serviceLink: 'https://ieum.depth-mju.co.kr/',
    githubLink: [
      'https://github.com/DEPthes/2nd-MVP-IEUM-Client',
      'https://github.com/DEPthes/2nd-MVP-IEUM-Server',
    ],
    member: {
      'PM LEADER': '이여원',
      'CLIENT LEADER': '박지수',
      'SERVER LEADER': '백계환',
      'DESIGN LEADER': '김민주',
      PM: '조민경',
      CLIENT: ['나범수', '이가은', '장현준'],
      SERVER: '정지수',
    },
  },
  {
    id: 'began',
    name: '비긴, 비건',
    thumbnail: '/image/project/background/began.png',
    logo: '/image/project/logo/beganL.png',
    detailImg: null,
    cohort: '2기',
    projectType: 'MVP',
    platform: 'APP',
    slogan: '“비건=채식주의?NO! 비건은 그렇게 어렵지 않아”',
    description:
      '“비건=채식주의? NO! 비건은 그렇게 어렵지 않아” 커져가는 비건 시장 속에서 헤매는 “비기너”들과 함께 “비거너”가 되는 여정을 함께합니다. ',
    serviceLink: '',
    githubLink: [
      'https://github.com/DEPthes/2nd-MVP-BeginVegan-Client',
      'https://github.com/DEPthes/2nd-MVP-BeginVegan-Server',
    ],
    member: {
      'PM LEADER': '문규원',
      'CLIENT LEADER': '최정현',
      'SERVER LEADER': '강승우',
      'DESIGN LEADER': '김세림',
      PM: '김민서',
      CLIENT: '서윤지',
      SERVER: '박세진',
    },
  },
  {
    id: 'water',
    name: '물은 답을 알고 있다',
    thumbnail: '/image/project/background/water.png',
    logo: '/image/project/logo/waterL.png',
    detailImg: null,
    cohort: '2기',
    projectType: 'MVP',
    platform: 'APP',
    slogan: '나쁜 감정을 좋은 감정으로, 사라지는 일기 앱 서비스',
    description:
      '사용자들은 부정적인 감정을 ‘물’에 털어내고 상황에 맞는 답변을 통해 위로 또는 공감을 받을 수 있습니다. 일기를 작성하여 결정이 완성되면 결정에 담긴 답변을 열람함으로써, 지난 날을 되돌아볼 수 있습니다.',
    serviceLink: '',
    githubLink: [
      'https://github.com/DEPthes/2nd-MVP-Water-Client',
      'https://github.com/DEPthes/2nd-MVP-Water-Server',
    ],
    member: {
      'PM LEADER': '이인서',
      'CLIENT LEADER': '김희윤',
      'SERVER LEADER': '김해찬',
      'DESIGN LEADER': '이다은',
      PM: '전하늘',
      CLIENT: '이보현',
      SERVER: '노은빈',
    },
  },
  {
    id: 'money',
    name: '금융원정대',
    thumbnail: '/image/project/background/money.png',
    logo: '/image/project/logo/moneyLogo.png',
    detailImg: null,
    cohort: '2기',
    projectType: 'MAIN',
    platform: 'WEB',
    slogan: '당신의 위대한 여정이 시작된다!',
    description:
      '복잡한 금융 용어와 상품들 탓에 어려움을 느낀 적이 있나요? 상품이 너무 많아 금융 상품을 비교하는 서비스가 번거로웠던 경험이 있나요? 금융이 어려운 청년들을 위한, 수많은 금융 정보들을 누구나 쉽고 빠르게 볼 수 있는 서비스를 만들었어요. "금융원정대"와 함께라면, 여러분에게 맞는 금융 상품을 쉽게 찾을 수 있어요',
    serviceLink: 'https://www.finfellows.co.kr/',
    githubLink: [
      'https://github.com/FinFellows/web',
      'https://github.com/FinFellows/Server',
    ],
    member: {
      'PM LEADER': '박수성',
      'CLIENT LEADER': '박지수',
      'SERVER LEADER': '노은빈',
      'DESIGN LEADER': '김민주',
      PM: '백도현',
      CLIENT: ['이보현', '이가은', '장현준'],
      SERVER: ['박세진', '이재혁'],
      DESIGNER: '김태진',
    },
  },
  {
    id: 'exhibition',
    name: '전시로그',
    thumbnail: '/image/project/background/exhibition.png',
    logo: '/image/project/logo/exhibitionLogo.png',
    detailImg: null,
    cohort: '2기',
    projectType: 'MAIN',
    platform: 'APP',
    slogan: '전시를 기록하다 : 전시회 정보 플랫폼',
    description:
      '사용자가 전시회의 정보를 보다 쉽게 찾도록 도와주는 서비스로, 서비스를 통해 각 전시회의 세부 정보를 확인할 수 있어요. 사용자들이 별점과 감상평을 통해 자신의 생각과 경험을 나눌 수 있게 함으로써 풍부하고 만족스러운 전시회 경험을 쌓을 수 있도록 지원해요!',
    serviceLink:
      'https://play.google.com/store/apps/details?id=com.andletgo.jeonsilog&hl=ko',
    githubLink: [
      'https://github.com/AndLetgo/2nd-Main-JeonsiLog-Client',
      'https://github.com/AndLetgo/2nd-Main-JeonsiLog-Server',
    ],
    member: {
      'PM LEADER': '조민경',
      'CLIENT LEADER': '서윤지',
      'SERVER LEADER': '백계환',
      'DESIGN LEADER': '김세림',
      PM: '이인서',
      CLIENT: ['문장훈', '임준형'],
      SERVER: '강승우',
    },
  },
  {
    id: 'idea',
    name: '아이디어 캠퍼스',
    thumbnail: '/image/project/background/idea.png',
    logo: '/image/project/logo/ideaLogo.png',
    detailImg: null,
    cohort: '2기',
    projectType: 'MAIN',
    platform: 'WEB',
    slogan: '각 팀의 작품을 구경하고, 나만의 아이디어를 펼쳐보세요!',
    description:
      '대학생들은 뛰어난 아이디어와 개발 능력을 가지고 있지만 이를 널리 알리고 사용자를 모으는데 어려움을 겪는 경우가 많아요. 아이디어 캠퍼스는 그들의 노력을 더 가치있게 만들어주고, 사용자들에게 혁신적인 서비스와 아이디어를 소개함으로써 IT문화의 발전을 촉진시켜요.',
    serviceLink: 'https://ideacampus.vercel.app/',
    githubLink: [
      'https://github.com/IDEA-CAMPUS/IDEA-CAMPUS-Client-Main',
      'https://github.com/IDEA-CAMPUS/IDEA-CAMPUS-Server',
    ],
    member: {
      'PM LEADER': '허재석',
      'CLIENT LEADER': '나범수',
      'SERVER LEADER': '정지수',
      'DESIGN LEADER': '이다은',
      PM: '전하늘',
      CLIENT: ['박상민', '정상경'],
      SERVER: ['배수연', '이상남'],
      DESIGNER: '봉서연',
    },
  },
  //3기 시작
  {
    id: 'mbtiN',
    name: 'N력 키우기',
    thumbnail: '/image/project/background/mbtiN.png',
    logo: '/image/project/logo/mbtiN.png',
    detailImg: '/image/project/detailBackground/mbtiN.png',
    cohort: '3기',
    projectType: 'MVP',
    platform: 'WEB',
    slogan: '사람들의 상상력을 키울 수 있는 서비스',
    description:
      '매일 달라지는 주제에 대해 나라면 어떻게 했을 지 작성해보는 \'나였다면\'을 통해 상상력을 기를 수 있습니다. 또 다른 사람의 상상의 나래를 탐험해보면서 나보다 더 뛰어난 상상가의 능력을 참고할 수 있습니다. N력 키우기와 함께 상상의 나래를 펼쳐봐요!',
    serviceLink: 'https://n-s.netlify.app/',
    githubLink: [
      'https://github.com/DEPthes/3rd-MVP-NS-Web',
      'https://github.com/DEPthes/3rd-MVP-NS-Server',
    ],
    member: {
      'PM': '이재형',
      'DESIGN LEADER': '서예원',
      'CLIENT LEADER': '이가은',
      'SERVER LEADER': '정지수',
      PLAN: '우준식',
      CLIENT: ['김서영', '박하영'],
      SERVER: ['이재혁', '이지수'],
    },
  },
  {
    id: 'growMe',
    name: '나 키우기',
    thumbnail: '/image/project/background/growMe.png',
    logo: '/image/project/logo/growMe.png',
    detailImg: '/image/project/detailBackground/growMe.png',
    cohort: '3기',
    projectType: 'MVP',
    platform: 'APP',
    slogan: '게임형 To-do-List',
    description:
      '목표를 퀘스트로 설정하고, 그 퀘스트를 완료할 때마다 캐릭터인 \'나\'를 성장시키는 서비스입니다. 어린 시절 게임을 통해 느꼈던 성취감과 재미를 바탕으로 어른이 된 지금도 목표를 달성하는 과정에서 그 즐거움을 다시 찾을 수 있도록 돕고자 합니다. 나 키우기를 통해 하루를 퀘스트로 만들어보세요!',
    serviceLink: 'https://drive.google.com/file/d/1Ir9D45phg_akBX8O-n10olw8u8OQRlXM/view',
    githubLink: [
      'https://github.com/DEPthes/3rd-MVP-NoPlanB-Android',
      'https://github.com/DEPthes/3rd-MVP-NoPlanB-Server',
    ],
    member: {
      'PM': '남재희',
      'DESIGN LEADER': '유혜진',
      'CLIENT LEADER': '함범준',
      'SERVER LEADER': '노은빈',
      PLAN: '신아름',
      CLIENT: '김하은',
      SERVER: '이상남',
    },
  },
  {
    id: 'deplog',
    name: 'DEPlog',
    thumbnail: '/image/project/background/deplog.png',
    logo: '/image/project/logo/deplog.png',
    detailImg: '/image/project/detailBackground/deplog.png',
    cohort: '3기',
    projectType: 'MVP',
    platform: 'WEB',
    slogan: 'DEPth 회원을 위한 전문 기술 블로그 플랫폼',
    description:
      'DEPlog에서는 DEPth 활동 중 쌓은 지식이나 경험을 공유하며 활발한 커뮤니티 활동을 통해 서로에게 동기를 부여할 수 있습니다. 회원들은 게시글 작성, 댓글 달기, 아바타 생성 기능을 통해 자신만의 개성을 표현하고, 타인의 피드백을 받으며 더욱 높은 품질의 블로그 글을 작성할 수 있습니다. 비회원 사용자 또한 DEPlog에 방문할 수 있으며 DEPth 회원들이 작성한 기술 블로그를 통해 동아리에 대한 정보를 쌓을 수 있습니다.',
    serviceLink: 'https://deplog.netlify.app/',
    githubLink: [
      'https://github.com/DEPthes/3rd-MVP-Overload-Web',
      'https://github.com/DEPthes/3rd-MVP-Overload-Server',
    ],
    member: {
      'PM': '허은교',
      'DESIGN LEADER': '김민주',
      'CLIENT LEADER': '나범수',
      'SERVER LEADER': '강승우',
      PLAN: '조민경',
      CLIENT: ['김소연', '김홍민'],
      SERVER: '이재훈',
    },
  },
  {
    id: 'thinkabel',
    name: '띵커벨',
    thumbnail: '/image/project/background/thinkabel.png',
    logo: '/image/project/logo/thinkabel.png',
    detailImg: '/image/project/detailBackground/thinkabel.png',
    cohort: '3기',
    projectType: 'MVP',
    platform: 'APP',
    slogan: '명지대학교 공지사항 알림 서비스',
    description:
      '명지대학교 학생들이 중요한 학교 소식을 놓치지 않도록 키워드 등록을 통해 공지사항 업로드 알림을 받을 수 있습니다. 학교의 모든 공지사항을 한 곳에서 확인하고 즐겨찾기 기능으로 더욱 편리하고 효율적으로 학교생활을 관리하세요. 기다리고 있는 공지사항이 있다면? 이제 띵커벨이 알려드릴게요!',
    serviceLink: 'https://play.google.com/store/apps/details?id=com.neverland.thinkerbell&pcampaignid=web_share&pli=1',
    githubLink: [
      'https://github.com/DEPthes/3rd-MVP-Neverland-Android',
      'https://github.com/DEPthes/3rd-MVP-Neverland-Server',
    ],
    member: {
      'PM': '박하영',
      'DESIGN LEADER': '강민서',
      'CLIENT LEADER': '문장훈',
      'SERVER LEADER': '배수연',
      CLIENT: '김경민',
      SERVER: ['주도현', '민영은'],
    },
  },
  {
    id: 'spillTheTea',
    name: 'Spill The Tea',
    thumbnail: '/image/project/background/spillTheTea.png',
    logo: '/image/project/logo/spillTheTea.png',
    detailImg: '/image/project/detailBackground/spillTheTea.png',
    cohort: '3기',
    projectType: 'MAIN',
    platform: 'WEB',
    slogan: '당신의 이야기가 특별해지는 곳, 썰 푸는 장소',
    description:
      'Spill the tea = 누군가가 비밀이거나 흥미로운 소식을 이야기할 때 사용되는 영어 속어, 짤 기능, 소설화 기능, 음성출력 기능 등을 이용하여 재미있게 "썰"을 풀 수 있는 서비스입니다. 사용자들은 썰을 열람하고 댓글을 통하여 소통할 수 있습니다.',
    serviceLink: 'https://spill-the-tea-site.netlify.app/',
    githubLink: [
      'https://github.com/THE-T-DEPth/spill-the-tea-web',
      'https://github.com/THE-T-DEPth/spill-the-tea-server',
    ],
    member: {
      'PM': '이혜원',
      'DESIGN LEADER': '강민서',
      'CLIENT LEADER': '김소연',
      'SERVER LEADER': '이재훈',
      PLAN: '이준혁',
      CLIENT: ['김서영', '박하영'],
      SERVER: '배수연',
    },
  },
  {
    id: 'payKids',
    name: 'PayKids',
    thumbnail: '/image/project/background/payKids.png',
    logo: '/image/project/logo/payKids.png',
    detailImg: '/image/project/detailBackground/payKids.png',
    cohort: '3기',
    projectType: 'MAIN',
    platform: 'APP',
    slogan: '어린이들을 위한 금융 교육 어플',
    description:
      'PayKids는 어린이가 접근하고 배우기 어려운 금융 교육 퀴즈를 통해 풀어내어 도전과 성취감을 느끼며 배움의 재미를 경험할 수 있도록 합니다. 또한, 손쉽게 기록할 수 있는 용돈기입장을 통해 어린이가 올바른 소비습관을 형성하도록 하는 것을 목표로 합니다.',
    serviceLink: 'https://drive.google.com/file/d/1E-uql_z-_y1EvkVUl_9otQ1pKRYz1-8l/view?usp=sharing',
    githubLink: [
      'https://github.com/PayKids/paykids-android',
      'https://github.com/PayKids/paykids-server',
    ],
    member: {
      'PM': '방재완',
      'DESIGN LEADER': '서예원',
      'CLIENT LEADER': '함범준',
      'SERVER LEADER': '주도현',
      PLAN: '정우진',
      CLIENT: '김경민',
      SERVER: '민영은',
    },
  },
  {
    id: 'dailyNews',
    name: '일거수일투족',
    thumbnail: '/image/project/background/dailyNews.png',
    logo: '/image/project/logo/dailyNews.png',
    detailImg: '/image/project/detailBackground/dailyNews.png',
    cohort: '3기',
    projectType: 'MAIN',
    platform: 'WEB',
    slogan: '일상을 뉴스처럼 기록은 간단하게, 기억은 생생하게!',
    description:
      '처음 도전한 경험, 꾸준히 이어온 습관, 오랜만에 한 활동 등을 뉴스처럼 만들어 공유하며, 일상의 순간들을 더욱 즐겁고 의미 있게 기념할 수 있도록 돕습니다. 일거수일투족은 단순한 기록을 넘어, 당신만의 특별한 이야기를 만들어주는 새로운 방식의 라이프 로그 서비스입니다.',
    serviceLink: 'https://play.google.com/store/apps/details?id=com.ilgusu.movelog&pcampaignid=web_share',
    githubLink: [
      'https://github.com/Move-Log/Move-Log-Android',
      'https://github.com/Move-Log/Move-Log-Server',
    ],
    member: {
      'PM': '이재형',
      'DESIGN LEADER': '유혜진',
      'CLIENT LEADER': '문장훈',
      'SERVER LEADER': '노은빈',
      PLAN: '임다빈',
      DESIGN: '김민주',
      CLIENT: '김하은',
    },
  },
  {
    id: 'wishWesee',
    name: 'WishWesee',
    thumbnail: '/image/project/background/wishWesee.png',
    logo: '/image/project/logo/WishWesee.png',
    detailImg: '/image/project/detailBackground/wishWesee.png',
    cohort: '3기',
    projectType: 'MAIN',
    platform: 'APP',
    slogan: '초대의 재해석 : 우리가 만나는 순간을 특별하게 만드는 여정',
    description:
      '저녁 약속부터 생일 파티까지, 사람들의 일상 속 다양한 모임은 언제나 초대부터 시작합니다.<br/> 우리만의 특별한 초대장을 만들어 보낼 수 있는 서비스! 재미있게, 감성적으로, 혹은 격식을 갖춘 방식으로 초대장을 만들어보세요.<br/> 다양한 카드와 커스터마이징 옵션을 통해 모임이 지닌 감성과 의미를 함께 전달할 수 있습니다.',
    serviceLink: 'https://chochocho.wishwesee.n-e.kr/',
    githubLink: [
      'https://github.com/WishWesee/Client',
      'https://github.com/WishWesee/Server',
    ],
    member: {
      'PM': '박하영',
      'DESIGN LEADER': '한효주',
      'CLIENT LEADER': '김홍민',
      'SERVER LEADER': '이지수',
      CLIENT: ['나범수', '이가은'],
      SERVER: '정지수',
    },
  },
  //4기 시작
  {
    id: 'atory',
    name: 'Atory',
    thumbnail: '/image/project/background/atory.png',
    logo: '/image/project/logo/atory.png',
    detailImg: '/image/project/background/atory.png',
    cohort: '4기',
    projectType: 'MVP',
    platform: 'WEB',
    slogan: '작품 전시 및 판매 기회를 제공하는 참여형 예술 플랫폼',
    description:
      '아토리는 청년 작가에게 작품 전시 및 판매 기회를 제공하는 참여형 예술 플랫폼입니다. 청년 작가에게는 포트폴리오 공간 제공, 아트 컬렉터는 작가와 작품 아카이브를 통해 신인 작가 탐색과 예술 취향 파악, 갤러리의 청년 작가를 발굴을 통해 미술시장 확대에 기여할 수 있습니다.',
    serviceLink: '',
    githubLink: [
      'https://github.com/DEPthes/4th-MVP-ARTORY-Web',
      'https://github.com/DEPthes/4th-MVP-ATORY-Server',
    ],
    member: {
      'PM': '조연서',
      'DESIGN LEADER': '배서윤',
      'CLIENT LEADER': '박기현',
      'SERVER LEADER': '주도현',
      PLAN: ['박하영', '윤지원'],
      DESIGN: '박소연',
      CLIENT: ['김서영', '박하영'],
      SERVER: ['강현준', '이지수', '임다빈'],
    },
  },
  {
    id: 'learnit',
    name: 'LearnIt',
    thumbnail: '/image/project/background/learnit.png',
    logo: '/image/project/logo/learnit.png',
    detailImg: '/image/project/background/learnit.png',
    cohort: '4기',
    projectType: 'MVP',
    platform: 'WEB',
    slogan: 'Learn it with IT',
    description:
      'LearnIT은 스마트 그룹 스터디 플랫폼으로 스터디 그룹을 개설하거나 참여할 수 있으며, 학습 진도를 따라 AI 기반의 퀴즈 풀이 기능을 활용할 수 있습니다. \n이를 통해 사용자는 기술을 기반으로 한 협력적 학습 환경을 경험할 수 있습니다.',
    serviceLink: 'https://learnit.myunghyun.me/',
    githubLink: [
      'https://github.com/DEPthes/4th-MVP-LearningCrew-Web',
      'https://github.com/DEPthes/4th-MVP-LearningCrew-Server',
    ],
    member: {
      'PM': '노진솔',
      'DESIGN LEADER': '문승규',
      'CLIENT LEADER': '김소연',
      'SERVER LEADER': '천명현',
      PLAN: '임재이',
      DESIGN: '김채현',
      CLIENT: ['이준혁', '오동이'],
      SERVER: ['김서영', '김태현', '이재훈'],
    },
  },
  {
    id: 'ootday',
    name: 'OOTDay',
    thumbnail: '/image/project/background/ootday.png',
    logo: '/image/project/logo/ootday.png',
    detailImg: '/image/project/background/ootday.png',
    cohort: '4기',
    projectType: 'MVP',
    platform: 'APP',
    slogan: '스타일링, 아이템 추천 서비스',
    description:
      'OOTDay는 개성은 뽐내고 싶지만 매일의 선택으로 스트레스를 받는 사람들을 위한 스타일링 및 아이템 추천 서비스입니다.\n내 옷장을 바탕으로 상황과 취향에 맞는 코디와 어울리는 아이템까지 손쉽게 찾아줍니다.',
    serviceLink: '',
    githubLink: [
      'https://github.com/DEPthes/4th-MVP-OOTDay-Android',
      'https://github.com/DEPthes/4th-MVP-OOTDay-Server',
    ],
    member: {
      'PM': '강안나',
      'DESIGN LEADER': '김소정',
      'CLIENT LEADER': '안태훈',
      'SERVER LEADER': '송성호',
      PLAN: '최동재',
      SERVER: ['강명준', '민영은', '오원택'],
    },
  },
    // 4기 메인프 추가
  {
    id: 'finvibe',
    name: 'FinVibe',
    thumbnail: '/image/project/background/FinVibe.png',
    logo: '/image/project/logo/FinVibe.png',
    detailImg: '/image/project/detailBackground/FinVibe.png',
    cohort: '4기',
    projectType: 'MAIN',
    platform: 'WEB',
    slogan: '두려움은 없애고, 투자의 즐거움을 깨우다',
    description:
        'MZ세대 투자자를 위한 효율적인 AI 학습과 뉴스&토론부터 짜릿한 가상 투자 챌린지까지! 성공적인 투자 여정을 막연한 감이 아닌 확실한 실전 경험에서 시작합니다. 내 돈 잃기 전 미리 부딪혀보고, 함께 성장하며 진짜 실력을 만드는 FinVibe',
    serviceLink: 'https://finvibe.space',
    githubLink: [
      'https://github.com/DEPth-FinVibe/FinVibe-fe',
      'https://github.com/DEPth-FinVibe/Finvibe_Backend_Manifest',
    ],
    member: {
      PM: '임재이',
      'DESIGN LEADER': '박소연',
      'CLIENT LEADER': '오동이',
      'SERVER LEADER': '천명현',
      PLAN: '최동재',
      CLIENT: '박기현',
      SERVER: ['오원택', '강현준'],
    },
  },
  {
    id: 'deokive',
    name: 'DEOKIVE',
    thumbnail: '/image/project/background/DEOKIVE.png',
    logo: '/image/project/logo/DEOKIVE.png',
    detailImg: '/image/project/detailBackground/DEOKIVE.png',
    cohort: '4기',
    projectType: 'MAIN',
    platform: 'WEB',
    slogan: '덕질의 순간을 기록하는 아카이빙 플랫폼',
    description:
        '덕카이브(Deokive)는 덕질(Deok)+아카이브(Archive)의로, 최상의 모든 덕질을 기록하고 저장하는 장소입니다. 디데이, 캘린더, 다이어리 등의 기능으로 덕질의 기록을 편리하게 관리하고, 커뮤니티, 피드 기능으로 세상의 다양한 덕질을 공유하고 경험할 수 있는 장을 제공합니다.',
    serviceLink: 'https://deokive.vercel.app/',
    githubLink: [
      'https://github.com/Deokive/FE',
      'https://github.com/Deokive/BE',
    ],
    member: {
      PM: '강안나',
      'DESIGN LEADER': '김소정',
      'CLIENT LEADER': '김정민',
      'SERVER LEADER': '김태현',
      PLAN: '조연서',
      CLIENT: '최고은',
      SERVER: '송성호',
    },
  },
  {
    id: 'aim',
    name: 'AiM',
    thumbnail: '/image/project/background/AiM.png',
    logo: '/image/project/logo/AiM.png',
    detailImg: '/image/project/detailBackground/AiM.png',
    cohort: '4기',
    projectType: 'MAIN',
    platform: 'WEB',
    slogan: 'AI와 목표를 조준하는 커리어 플레이, AiM에 도전하세요',
    description:
        'AiM은 AI가 분석한 사용자의 목표를 기반으로, 개인에게 최적화된 실전형 챌린지를 제공하는 직무 맞춤 성장 플랫폼입니다. AiM은 직무에 바로 연결되는 경험과 결과물을 통해 사용자가 스스로의 커리어 방향을 설정하고, 지속적으로 성장할 수 있도록 돕습니다.',
    serviceLink: 'https://aim-targeter.netlify.app/',
    githubLink: [
      'https://github.com/AiM-Club/AiM-web',
      'https://github.com/AiM-Club/AiM-server',
    ],
    member: {
      PM: '노진솔',
      'DESIGN LEADER': '배서윤',
      'CLIENT LEADER': '전민근',
      'SERVER LEADER': '이재훈',
      PLAN: '안준규',
      CLIENT: '김소연',
      SERVER: ['김서영', '임다빈'],
    },
  },
  {
    id: 'seatnow',
    name: 'SEAT NOW',
    thumbnail: '/image/project/background/Seatnow.png',
    logo: '/image/project/logo/Seatnow.png',
    detailImg: '/image/project/detailBackground/Seatnow.png',
    cohort: '4기',
    projectType: 'MAIN',
    platform: 'APP',
    slogan: '걷지 말고, 지금 바로 시트나우',
    description:
        '개강 파티부터 단체 뒷풀이까지, 대학가 술집의 실시간 좌석 정보를 한눈에 볼 수 있습니다. 몇 명이 앉을 수 있는지, 어디에 자리가 비었는지를 직접 돌아다니지 않고도 빠르고 효율적으로 탐색해보세요!',
    serviceLink: 'https://play.google.com/store/apps/details?id=com.gmg.seatnow&hl=ko',
    githubLink: [
      'https://github.com/SEAT-NOW/Android',
      'https://github.com/SEAT-NOW/Server',
    ],
    member: {
      PM: '윤지원',
      'DESIGN LEADER': '김채현',
      'ANDROID LEADER': '안태훈',
      'SERVER LEADER': '강명준',
      DESIGN: '이은교',
      SERVER: '이지수',
    },
  },
];
